import React, { useEffect, useState } from "react";
import SliderAuth from "../../../components/SliderAuth/SliderAuth";
import { images } from "../../../config/images";
import {
    Grid,
    FormControl,
    OutlinedInput,
    InputAdornment,
} from "@mui/material";
import { Button } from "../../../components/Button/button"
import { useNavigate, Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OTPInput, { ResendOTP } from "otp-input-react";
import { toast } from "react-toastify";
import { auth, signInWithPhoneNumber, setUpRecaptcha } from "../../../config/firebase";
import translations from "../../../config/language";

const VerifyMobileNumber = ({ onCancelClick, mobileNo ,setMobileVerify }) => {

    const notify = (message) => {
        toast.error(message, {
            theme: "colored",
            position: toast.POSITION_TOP_RIGHT,
            toastClassName: "custom-toast",
        });
    };

    const notifySuccess = (message) => {
        toast.success(message, {
            theme: "colored",
            position: toast.POSITION_TOP_RIGHT,
            toastClassName: "custom-toast",
        });
    };

    const [OTP, setOTP] = useState("");
    const [visibleOTP, setvisibleOTP] = useState(false);
    const [seconds, setSeconds] = useState(60);
    const [minutes, setMinutes] = useState(1);

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }

            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(interval);
                }
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);


    const handleSubmit = async () => {
        if (OTP.length == 6) {
            onCancelClick();
            setMobileVerify(true);
        } else {
            notify("Please Enter valid OTP.");
        }
    };

      const sendOtp = async (phoneNumber) => {
            if (!phoneNumber) {
                toast.error("Please enter a mobile number.");
                return;
            }    
            const formattedPhoneNumber = `+91 ${phoneNumber}`;
            try {
                // ✅ Ensure reCAPTCHA is initialized
                setUpRecaptcha();
                // ✅ Send OTP
                const confirmationResult = await signInWithPhoneNumber(auth, formattedPhoneNumber, window.recaptchaVerifier);
                window.confirmationResult = confirmationResult;
                notifySuccess("OTP Sent Successfully!");
            } catch (error) {
                console.log("error", error)
                notify(error.response.data.message);
            }
        };


    const handleResendOTp = async () => {
        sendOtp(mobileNo)
    }

       const language = process.env.REACT_APP_LANGUAGE;
    return (
        <>
            <div></div>
            <Grid container className="main-container">
                <SliderAuth />
                <Grid item xs={12} md={5} lg={4} className="signIn-form-wrap">
                    <div className="logo-div">
                        <Link to="#" onClick={() => onCancelClick()}
                            className="page-back-btn"> {/* navigate to back screen */}
                            <ArrowBackIcon className="back-arrow-icon" />
                        </Link>
                        <div className="pb-2">
                            <img src={images.twoStepLogo} alt="Sign Up" className="signIn-logo" />
                        </div>
                    </div>
                    <h3 className="text-center singIn-title">{translations[language].twoStepVerification}</h3>

                    {/* Sing up Form  */}

                    <div className="signUp-form">
                        <div className="forgot-password-div">
                        {translations[language].otpVerifyText}
                        {translations[language].verification}
                        </div>
                        <div className="otp-input wrap">
                            <OTPInput
                                value={OTP}
                                onChange={setOTP} // Fix the typo here
                                autoFocus
                                OTPLength={6}
                                otpType="number"
                                disabled={false}
                                secure={!visibleOTP}
                                className="OTP"
                            />
                            {visibleOTP ? (
                                <img
                                    src={images.viewIcon}
                                    alt=""
                                    className="view icon OTP"
                                    onClick={() => setvisibleOTP(false)}
                                />
                            ) : (
                                <img
                                    src={images.eyecloseIcon}
                                    alt=""
                                    className="view icon OTP"
                                    onClick={() => setvisibleOTP(true)}
                                />
                            )}
                        </div>
                        <div className="countdown-text d-flex justify-content-center pt-4 pb-4">
                            {seconds > 0 ? (
                                <>
                                    <p className="d-flex" style={{ marginLeft: "50px" }}>
                                    {translations[language].pleaseWait} {seconds < 10 ? `0${seconds}` : seconds}{" "}
                                        {translations[language].seconds}
                                    </p>
                                </>
                            ) : (
                                <div
                                    style={{ textAlign: "center" }}
                                    className="abc"
                                >
                                    <div>{translations[language].didntReceiveCode}</div>
                                    <div>
                                        <a
                                            style={{
                                                cursor: "pointer",
                                                fontWeight: 500,
                                                color: "#31A05F"
                                            }}
                                            onClick={() => handleResendOTp()}
                                        >
                                            {translations[language].resendCode}
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                    <div id="recaptcha-container"></div>
                    <div style={{ marginTop: "2rem", width: "100%", padding: "20px 0" }}>
                        <Button
                            title="Submit"
                            classname={"custom-button"}
                            onClick={handleSubmit}
                        />
                    </div>
                </Grid>
            </Grid>
        </>
    )
}
export default VerifyMobileNumber;